export const SEARCH_VALUE_CHANGED = 'search_value_changed';
export const searchValueChanged = (searchValue) => ({
  type: SEARCH_VALUE_CHANGED,
  payload: searchValue,
});

export const SHOW_MORE_RESULTS = 'show_more_results';
export const showMoreResults = () => ({
  type: SHOW_MORE_RESULTS,
});

export const OU_TYPE_SEARCH_FILTER_CHANGED = 'ou_type_changed';
export const ouTypeSearchFilterChanged = (ouType) => ({
  type: OU_TYPE_SEARCH_FILTER_CHANGED,
  payload: ouType,
});

export const SEARCH_RESULTS_FETCHED = 'search_results_fetched';
export const searchResultsFetched = (searchResults) => ({
  type: SEARCH_RESULTS_FETCHED,
  payload: searchResults,
});

export const OUS_FETCHED_FOR_HELPDESK = 'ous_fetched_for_helpdesk';
export const ousFetchedForHelpdesk = (results, ouType) => ({
  type: OUS_FETCHED_FOR_HELPDESK,
  payload: {
    results,
    ouType,
  },
});

export const OU_FETCHED_BY_INSTITUTION_NUMBER = 'ou_fetched_by_institution_number';
export const ouFetchedByInstitutionNumber = (institutionNumber) => ({
  type: OU_FETCHED_BY_INSTITUTION_NUMBER,
  payload: institutionNumber,
});
